import { render, staticRenderFns } from "./DesktopShopPage.vue?vue&type=template&id=107ffcef&scoped=true"
import script from "./DesktopShopPage.vue?vue&type=script&lang=js"
export * from "./DesktopShopPage.vue?vue&type=script&lang=js"
import style0 from "./DesktopShopPage.vue?vue&type=style&index=0&id=107ffcef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "107ffcef",
  null
  
)

export default component.exports